import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 56px-high app topbar. Pure layout — consumers compose their own store
 * selector / role chip / user chip via `left` and `right`.
 */
export function Topbar({ left, right, children }) {
    return (_jsxs("div", { style: {
            minHeight: 56,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "8px 12px",
            gap: 8,
            rowGap: 6,
            justifyContent: "space-between",
        }, children: [left ?? children, right] }));
}
//# sourceMappingURL=Topbar.js.map